import React from 'react';

export interface IIntelligenceScale {
  /**
   * Whether the responsive scale is active for this subtree. False everywhere the
   * `intelligence_responsive_layout` flag is off, and the default outside the content scope.
   *
   * Components read this to choose a LAYOUT MECHANISM, not a size: a px length that merely has to
   * follow the scale needs no context at all, because `scaledPx` already resolves to the drawn
   * value when the property is unset. It exists for the cases where following the column means
   * measuring, which mounts an observer and changes the element's own box - work that must not
   * happen at all when the flag is off.
   */
  responsive: boolean;
}

export const INTELLIGENCE_SCALE_DEFAULT: IIntelligenceScale = { responsive: false };

const IntelligenceScaleContext = React.createContext<IIntelligenceScale>(
  INTELLIGENCE_SCALE_DEFAULT
);

export const useIntelligenceScaleContext = (): IIntelligenceScale =>
  React.useContext(IntelligenceScaleContext);

export default IntelligenceScaleContext;
